import axios from 'axios';
import { settings } from '@/plugins/settings';

export interface IApiKeyEndpoint {
  id: number;
  slug: string;
  name: string;
  method: string | null;
  path: string | null;
  description: string | null;
}

export interface IApiKey {
  id: number;
  name: string;
  created_by: number;
  created_at: string | null;
  last_used_at: string | null;
  revoked_at: string | null;
  endpoint_ids: number[];
}

export const apiKeysService = {
  fetchAll(page: number = 1, perPage: number = 15): Promise<{ data: IApiKey[]; current_page: number; per_page: number; total: number }> {
    return axios({
      url: settings.endpoint + 'apiKeys',
      method: 'GET',
      params: { page, per_page: perPage },
    }).then((response: any) => {
      const outer = response && response.data;
      const d = (outer && outer.data) || outer;
      return {
        data: d && Array.isArray(d.data) ? d.data : [],
        current_page: (d && d.current_page) || 1,
        per_page: (d && d.per_page) || perPage,
        total: (d && d.total) || 0,
      };
    });
  },

  fetchEndpointsCatalog(): Promise<IApiKeyEndpoint[]> {
    return axios({
      url: settings.endpoint + 'apiKeys/endpoints',
      method: 'GET',
    }).then((response: any) => {
      const outer = response && response.data;
      const d = (outer && outer.data) || outer;
      return d && Array.isArray(d.data) ? d.data : [];
    });
  },

  create(name: string, endpointIds: number[]): Promise<IApiKey & { plain_key: string }> {
    return axios({
      url: settings.endpoint + 'apiKeys',
      method: 'POST',
      data: { name, endpoint_ids: endpointIds },
    }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data;
      return response.data;
    });
  },

  revoke(id: number): Promise<void> {
    return axios({
      url: settings.endpoint + 'apiKeys/' + id,
      method: 'DELETE',
    }).then(() => {});
  },
};
